import { useState } from 'react';
import { authService } from 'spec';
import restMethods from '../constants/aryRestMethods';
import { formatQueryString } from '../utils/Utils';

const hostName = window.paths.bhn;

function isObject(variable) {
  if (
    typeof variable === 'object' &&
    !Array.isArray(variable) &&
    variable !== null &&
    !(variable instanceof File)
  ) {
    return true;
  }
  return false;
}

function appendKeyToRemainingKey(prevKey, remainingKey) {
  if (prevKey.slice(-1) === '.') {
    return `${prevKey}[${remainingKey}]`;
  }
  return `${prevKey}[${remainingKey}]`;
}

function appendObjectValueToFormData(formData, key, object) {
  const objectKeys = Object.keys(object);
  for (let i = 0; i < objectKeys.length; i++) {
    const objectKey = objectKeys[i];
    const objectValue = object[objectKey];
    if (Array.isArray(objectValue)) {
      appendArrayValueToFormData(
        formData,
        appendKeyToRemainingKey(key, objectKey),
        objectValue
      );
    } else if (isObject(objectValue)) {
      appendObjectValueToFormData(
        formData,
        appendKeyToRemainingKey(key, objectKey),
        objectValue
      );
    } else if (objectValue !== undefined && objectValue !== false) {
      formData.append(appendKeyToRemainingKey(key, objectKey), objectValue);
    }
  }
}

function appendArrayValueToFormData(formData, key, arrayValue) {
  if (arrayValue.length && arrayValue[0] instanceof File) {
    for (let i = 0; i < arrayValue.length; i++) {
      const file = arrayValue[i];
      formData.append(key, file);
    }
  } else {
    for (let i = 0; i < arrayValue.length; i++) {
      const element = arrayValue[i];
      if (Array.isArray(element)) {
        appendArrayValueToFormData(formData, `${key}[${i}]`, element);
      } else if (isObject(element)) {
        appendObjectValueToFormData(formData, `${key}[${i}]`, element);
      } else if (element !== undefined && element !== false) {
        formData.append(`${key}[${i}]`, element);
      }
    }
  }
}

const useAryRestData = (api, method, options) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState('');
  const [statusCode, setStatusCode] = useState('');

  async function postData({
    bodyData,
    isJsonFormatted = false,
    queryStrings = []
  }) {
    setLoading(true);
    let sentData;
    if (bodyData) {
      if (!isJsonFormatted) {
        sentData = new FormData();
        const dataKeys = Object.keys(bodyData);
        for (let i = 0; i < dataKeys.length; i++) {
          const key = dataKeys[i];
          const value = bodyData[key];
          if (Array.isArray(value)) {
            appendArrayValueToFormData(sentData, key, value);
          } else if (isObject(value)) {
            appendObjectValueToFormData(sentData, key, value);
          } else if (value !== undefined && value !== false) {
            sentData.append(key, value);
          }
        }
      } else {
        sentData = JSON.stringify(bodyData);
      }
    }
    const token = await authService.getAccessToken();

    let headers;
    const authorizationHeader = { Authorization: `Bearer ${token}` };
    if (isJsonFormatted) {
      headers = { ...authorizationHeader, 'Content-Type': 'application/json' };
    } else {
      headers = { ...authorizationHeader };
    }

    const response = await fetch(
      `${options?.hostName || hostName}${api}${formatQueryString(
        queryStrings
      )}`,
      {
        method: method || restMethods.post,
        headers,
        body: sentData
      }
    );

    setLoading(false);

    setStatusCode(response.status);
    const receivedData = await response.json();
    setData(receivedData);

    return { data: receivedData, status: response.status };
  }

  return [postData, { data, loading, status: statusCode }];
};

export default useAryRestData;
